<div
  *transloco="let t; read: 'calculator_result.recalculate'"
  class="flex flex-col gap-2 font-bold">
  <psc-section-title
    [title]="t('title')"
    alignment="left"
    size="normal"
    [lineWidthPercentage]="100"
    [lineThickness]="2"></psc-section-title>


  <form [formGroup]="formGroup"
        *ngIf="this.formGroup" class="flex flex-col gap-2">
    {{t('current_investment',
    {
      investmentCostPerKw: solarCalculatorResult.investmentCostPerKw | number,
      currency: solarCalculatorResult.currency,
      totalInvestment: (solarCalculatorResult.investmentCostPerKw * (+solarCalculatorResult.systemCapacity))  | number
    })}}
    <psc-input
      class="max-w-[340px]"
      prefix="kW/{{solarCalculatorResult.currency}}"
      [label]="t('investment')"
      formControlName="investment"></psc-input>


    <ng-container *ngIf="additionalData">
      {{t('min_max_capacity',
      {
        minCapacity: solarCalculatorResult.recalculateMin,
        maxCapacity: solarCalculatorResult.recalculateMax
      })}}
      <psc-input
        class="max-w-[340px]"
        prefix="kW"
        [label]="t('systemCapacity')"
        formControlName="systemCapacity"></psc-input>
    </ng-container>

    <ng-container *ngIf="solarCalculatorResult.incomeTax && solarCalculatorResult.incomeTaxLimit">
      <div class="whitespace-pre-wrap">{{t('income_tax_title', {
        incomeTax: solarCalculatorResult.incomeTax,
        incomeTaxLimit: solarCalculatorResult.incomeTaxLimit  | number,
        currency: solarCalculatorResult.currency
      })}}</div>
      <psc-input
        class="max-w-[340px]"
        prefix="%"
        [label]="t('incomeTax')"
        formControlName="incomeTax"></psc-input>
    </ng-container>


    <psc-button [label]="t('calculate')"
                (buttonClicked)="onSubmit()"
                [disabled]="!formGroup.valid"
                class="my-5 w-1/3"
                type="primary-blue-2"></psc-button>
  </form>
</div>
